/*
 * Sinh tự động từ /api/quiz/scorer — sửa tay là CI đỏ.
 * Sinh lại bằng: python3 bin/q4_sinh_bo_cham_diem.py
 * Phiên bản engine: v3
 */
(function () {
  const snapshot = window.__msBoDeSnapshot;
  if (!snapshot || !Array.isArray(snapshot.questions) || !window.QUIZ7) return;
  const meta = snapshot.questions.map((question) => ({
    id: question.id,
    tier: question.tier,
    positive: question.positive,
  }));

const AXIS_ORDER = [
  "ground",
  "joy",
  "line",
  "heart",
  "voice",
  "mind",
  "meaning",
];

const BANDS = {
  watering: {
    key: "watering",
    label: "Needs Watering",
    labelVi: "Đang cần tưới",
    icon: "🌱",
  },
  growing: {
    key: "growing",
    label: "Growing",
    labelVi: "Đang lớn",
    icon: "🌿",
  },
  bloom: {
    key: "bloom",
    label: "In Bloom",
    labelVi: "Đang nở",
    icon: "🌟",
  },
};

function oneDecimal(value) {
  return Math.round(value * 10) / 10;
}

function answerValue(answers, id) {
  const raw = answers && answers[id];
  const value = typeof raw === "number" ? raw : Number(raw);
  if (!Number.isFinite(value)) return 2;
  return Math.max(0, Math.min(4, Math.trunc(value)));
}

function scoreAnswer(answers, question) {
  const value = answerValue(answers, question.id);
  const points = question.positive ? value * 2.5 : (4 - value) * 2.5;
  return oneDecimal(points);
}

function average(values) {
  return oneDecimal(values.reduce((total, value) => total + value, 0) / values.length);
}

function heartState(give, receive) {
  if (give >= 7 && receive <= 3) return "OVERLOADED";
  if (give <= 3 && receive <= 3) return "BLOCKED";
  return "BALANCED";
}

function band(index) {
  if (index < 4) return BANDS.watering;
  if (index < 7) return BANDS.growing;
  return BANDS.bloom;
}

function mode(index, spread, state) {
  if (state === "OVERLOADED") return "HEART_OVERLOADED";
  if (index <= 2.5) return "LOW";
  if (index === 10) return "HIGH";
  if (spread === 0) return "FLAT";
  return "NORMAL";
}

/**
 * Score the v7.9 answer contract. `meta` is the published question metadata;
 * the formula deliberately does not carry a second copy of the question set.
 */
function scoreK24(answers, meta) {
  if (!Array.isArray(meta) || meta.length === 0) {
    throw new Error("K24 scoring requires published question metadata");
  }

  const questionsByTier = new Map();
  const questionsById = new Map();
  for (const question of meta) {
    if (
      !question ||
      typeof question.id !== "string" ||
      typeof question.tier !== "string" ||
      typeof question.positive !== "boolean"
    ) {
      throw new Error("K24 question metadata is incomplete");
    }
    if (questionsById.has(question.id)) {
      throw new Error(`K24 question metadata duplicates ${question.id}`);
    }
    const questions = questionsByTier.get(question.tier) || [];
    questions.push(question);
    questionsByTier.set(question.tier, questions);
    questionsById.set(question.id, question);
  }

  const axes = {};
  for (const tier of AXIS_ORDER) {
    const questions = questionsByTier.get(tier) || [];
    if (questions.length !== 3) {
      throw new Error(`K24 tier ${tier} must contain exactly 3 questions`);
    }
    axes[tier] = average(questions.map((question) => scoreAnswer(answers, question)));
  }

  const heart = questionsByTier.get("heart");
  const giveQuestion = questionsById.get("Q10");
  const receiveQuestions = [questionsById.get("Q11"), questionsById.get("Q12")];
  if (
    !giveQuestion ||
    !heart?.some((question) => question.id === "Q10") ||
    receiveQuestions.some((question) => !question || !heart.some((item) => item.id === question.id))
  ) {
    throw new Error("K24 heart metadata must contain Q10, Q11, and Q12");
  }
  const give = scoreAnswer(answers, giveQuestion);
  const receive = average(receiveQuestions.map((question) => scoreAnswer(answers, question)));
  const state = heartState(give, receive);
  const heartMid = axes.heart;

  const ranked = AXIS_ORDER
    .map((tier, order) => ({ tier, order, value: axes[tier] }))
    .sort((a, b) => a.value - b.value || a.order - b.order);
  const edge = ranked[0].tier;
  const edge2 = ranked[1].tier;
  const strength = ranked[ranked.length - 1].tier;
  const index = average(AXIS_ORDER.map((tier) => axes[tier]));
  const spread = oneDecimal(ranked[ranked.length - 1].value - ranked[0].value);
  const resultTiers = {
    root: axes.ground,
    joy: axes.joy,
    boundaries: axes.line,
    heart: { give, receive, state, mid: heartMid },
    voice: axes.voice,
    mind: axes.mind,
    meaning: axes.meaning,
  };

  // Stone content is attached by engine-score.ts through the existing engine
  // lookup; keeping that table out of this pure source prevents a second copy.
  return {
    tiers: resultTiers,
    axes,
    give,
    receive,
    heartState: state,
    index,
    band: band(index),
    edge,
    edge2,
    strength,
    mode: mode(index, spread, state),
    spread,
    stone: null,
    stone2: null,
  };
}

  // score7() in engine-score.ts attaches the stone the same way: scoreK24 stays
  // pure and the tier lookup comes from the engine already on the page. Without
  // this the browser result keeps stone = null and every {stoneName} renders empty.
  const stoneOf = window.QUIZ7.stoneOf;
  window.QUIZ7.score = function (answers) {
    const score = scoreK24(answers, meta);
    if (typeof stoneOf !== "function") return score;
    return Object.assign({}, score, {
      stone: stoneOf(score.edge),
      stone2: stoneOf(score.edge2),
    });
  };
})();
